module.exports = __webpack_public_path__ + "static/img/1-2.429b9ab9.png";